const getters = {
  getDrawer: (state) => state.drawer
}

const state = () => ({
  drawer: true
})

const actions = {}

const mutations = {
  setDrawer(state, drawer) {
    state.drawer = drawer
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
